import { useState } from "react";
import {
  Button,
  Typography,
  Card,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Divider,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import { FaPlusCircle } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faEnvelope, faUserShield, faToggleOn } from "@fortawesome/free-solid-svg-icons";
import COLORS from "../../../../../constants/colors";
import SnackbarAlert from "../../Reusbale/SnackbarAlert";
import baseURL from "../../config";
import { toast } from "react-toastify";

const AddAdminCard = () => {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("admin");
  const [status, setStatus] = useState("active");
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const handleCloseSnackbar = () => setSnackbar({ ...snackbar, open: false });

const handleSubmit = async () => {
  if (!name || !email) {
    toast.error("All fields are required.");
    return;
  }

  try {
    const response = await fetch(`${baseURL}/admin/create`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ name, email, role, status }),
    });

    const data = await response.json();

    if (response.ok) {
      toast.success("Admin created successfully! A reset password link has been sent.");
      setOpen(false);
      setName("");
      setEmail("");
      setRole("admin");
      setStatus("active");
    } else {
      toast.error(data.message || "Failed to create admin.");
    }
  } catch (error) {
    console.error("Submission error:", error);
    toast.error("Network error. Try again later.");
  }
};

  return (
    <>
      <Card
        sx={{
          backgroundColor: "#fff",
          borderRadius: "16px",
          boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
          border: "1px solid rgba(0,0,0,0.05)",
          p: 3,
          textAlign: "left",
          mx: "auto",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 800, color: "#1a1a2e", fontSize: "1.05rem", letterSpacing: "-0.3px", mb: 1 }}>
          Add a New Admin
        </Typography>
        <Typography variant="body2" sx={{ color: "#666", mb: 2, fontSize: "0.9rem" }}>
          Enter details for the new admin. Admins will have backend access based on their role.
        </Typography>
        <Button
          variant="contained"
          size="small"
          sx={{
            textTransform: "none",
            backgroundColor: COLORS.primary,
            borderRadius: "8px",
            fontWeight: "bold",
            fontSize: "0.9rem",
            px: 2,
            py: 1,
            "&:hover": { backgroundColor: COLORS.primary, opacity: 0.9 },
          }}
          onClick={() => setOpen(true)}
          startIcon={<FaPlusCircle />}
        >
          Add Admin
        </Button>
      </Card>

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle sx={{ fontWeight: "bold", fontSize: "1.3rem", bgcolor: "#f5f5f5" }}>
          Create New Admin
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ py: 3 }}>
          <TextField
            fullWidth
            label="Full Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            sx={{ mb: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <FontAwesomeIcon icon={faUser} style={{ color: COLORS.primary }} />
                </InputAdornment>
              ),
              sx: { borderRadius: "8px" },
            }}
          />
          <TextField
            fullWidth
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{ mb: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <FontAwesomeIcon icon={faEnvelope} style={{ color: COLORS.primary }} />
                </InputAdornment>
              ),
              sx: { borderRadius: "8px" },
            }}
          />
          <TextField
            fullWidth
            select
            label="Role"
            value={role}
            onChange={(e) => setRole(e.target.value)}
            sx={{ mb: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <FontAwesomeIcon icon={faUserShield} style={{ color: COLORS.primary }} />
                </InputAdornment>
              ),
              sx: { borderRadius: "8px" },
            }}
          >
            <MenuItem value="admin">Admin</MenuItem>
          </TextField>

          <TextField
            fullWidth
            select
            label="Status"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            sx={{ mb: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <FontAwesomeIcon icon={faToggleOn} style={{ color: COLORS.primary }} />
                </InputAdornment>
              ),
              sx: { borderRadius: "8px" },
            }}
          >
            <MenuItem value="active">Active</MenuItem>
            <MenuItem value="inactive">Inactive</MenuItem>
          </TextField>
        </DialogContent>
        <Divider />
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setOpen(false)} sx={{ textTransform: "none", color: COLORS.danger }}>
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            sx={{
              textTransform: "none",
              backgroundColor: COLORS.primary,
              borderRadius: "8px",
              px: 3,
            }}
          >
            Create Admin
          </Button>
        </DialogActions>
      </Dialog>

      <SnackbarAlert
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        handleClose={handleCloseSnackbar}
      />
    </>
  );
};

export default AddAdminCard;
